import { useState, useEffect } from "react";
import { getFlag } from "../utils/ApiCalls/FlagCalls";

const useFlag = (flagName) => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!flagName) {
      setLoading(false);
      return;
    }
    getFlag(flagName)
      .then((data) => {
        setEnabled(Boolean(data?.enabled));
      })
      .catch(() => setEnabled(false))
      .finally(() => setLoading(false));
  }, [flagName]);

  return { enabled, loading };
};

export default useFlag;
